import React from 'react';
import Logo from '../../assets/logo.png';
import XLogo from '../../assets/xlogo.svg';
import ConnectWallet from '../Wallet/ConnectWallet';
import AudioPlayer from '../AudioPlayer';
import '../../App.css'; 

const Header = () => {
  return (
    <header className="App-header">
      <div className="header-content">
        <img
          src={Logo}
          className="App-logo"
          alt="logo"
        />
        <h1 className="glitch">$CASHisDEAD</h1>
        <div className="wallet-audio-follow">
          <div className="follow-us-section">
            <a
              href="https://x.com/_CASHisDEAD_"
              target="_blank"
              rel="noopener noreferrer"
              className="follow-us-link"
            >
              <img src={XLogo} alt="Follow us on X" className="x-logo" />
            </a>
          </div>
          <ConnectWallet />
          <AudioPlayer />
        </div>
      </div>
    </header>
  );
};

export default Header;
